import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getMeasureDeadlines,
  ReminderAudience,
  remindAboutMeasure,
} from '../../../api/measureDeadlines';

export const MeasureDeadlinesQueryKey = 'HR_MEASURE_DEADLINES';

export const useMeasureDeadlinesQuery = (language: string, enabled = true) =>
  useQuery({
    queryKey: [MeasureDeadlinesQueryKey, language],
    queryFn: () => getMeasureDeadlines(language),
    enabled,
  });

export const useRemindAboutMeasureMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      measureId,
      to,
    }: {
      measureId: number;
      to: ReminderAudience;
    }) => remindAboutMeasure(measureId, to),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [MeasureDeadlinesQueryKey] }),
  });
};
